// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".email_textare {\n  width: 144px;\n  height: 24px;\n  border-radius: 3px;\n  background-color: rgb(240, 242, 245);\n}\n.email_removeIcon {\n  width: 12px;\n  height: 12px;\n  background-color: rgb(192, 196, 204);\n}\n.frequency_title {\n  width: 143px;\n  height: 30px;\n  color: rgb(0, 0, 0);\n  font-size: 22px;\n  padding-bottom: 44px;\n}\n.export_inputBox {\n  padding-bottom: 20px;\n}\n.customDialog .el-dialog__header {\n  padding: 0px 0px 0px 0px;\n}\n.dialog_title {\n  width: 143px;\n  height: 30px;\n  color: rgb(0, 0, 0);\n  font-size: 22px;\n}\n.dialog_font {\n  display: inline-block;\n  vertical-align: middle;\n  width: 64px;\n  height: 40px;\n  line-height: 40px;\n  color: rgb(0, 0, 0);\n  font-size: 16px;\n}\n.frequency_input input {\n  width: 300px;\n}\n.import_input input {\n  width: 260px;\n}\n.flag_message {\n  padding-bottom: 10px;\n  text-align: left;\n  padding-left: 10px;\n}\n.searchInput input {\n  font-size: 13px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"email_textare": "email_textare",
	"email_removeIcon": "email_removeIcon",
	"frequency_title": "frequency_title",
	"export_inputBox": "export_inputBox",
	"customDialog": "customDialog",
	"el-dialog__header": "el-dialog__header",
	"dialog_title": "dialog_title",
	"dialog_font": "dialog_font",
	"frequency_input": "frequency_input",
	"import_input": "import_input",
	"flag_message": "flag_message",
	"searchInput": "searchInput"
};
module.exports = ___CSS_LOADER_EXPORT___;
